import React from 'react';
import { TallSheet, YStack } from 'smoothie';

import type { BankAccountDisplayDetail } from '../../../banking/types/BankAccount';
import type { Transaction } from '../../../banking/types/Transactions';
import { EnrichedTransactionDetailsView } from './EnrichedTransactionDetails';

interface SproutTransactionDetailsSheetProps {
    isOpen: boolean;
    onClose: () => void;
    syncteraAccountId: string;
    account: BankAccountDisplayDetail | null;
    transaction: Transaction | null;
    isLoading: boolean;
    notFound: boolean;
}

/**
 * Bottom sheet that shows full transaction details for a transaction selected
 * from a Sprout chat transactions list. The enriched transaction is fetched by
 * the caller (data hooks must run outside this sheet's portal, which mounts
 * outside the app provider tree); this sheet only renders the result.
 */
export const SproutTransactionDetailsSheet = ({
    isOpen,
    onClose,
    syncteraAccountId,
    account,
    transaction,
    isLoading,
    notFound,
}: SproutTransactionDetailsSheetProps) => {
    return (
        <TallSheet
            isOpen={isOpen}
            onClose={onClose}
            title="Transaction details"
            showCloseButton={true}
        >
            <YStack flex={1} marginTop={24}>
                <EnrichedTransactionDetailsView
                    account={account}
                    transaction={transaction}
                    isLoading={isLoading}
                    notFound={notFound}
                    syncteraAccountId={syncteraAccountId}
                />
            </YStack>
        </TallSheet>
    );
};

export default SproutTransactionDetailsSheet;
